import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=51ac1162&scoped=true&"
import script from "./project-list.vue?vue&type=script&lang=ts&"
export * from "./project-list.vue?vue&type=script&lang=ts&"
import style0 from "./project-list.vue?vue&type=style&index=0&id=51ac1162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac1162",
  null
  
)

export default component.exports